import React from "react";
import EditClinic from "./EditClinic";

function ViewUser() {
  return <EditClinic disable={true} title={"Visualizar"}></EditClinic>;
}

export default ViewUser;
